import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import Button from "../../../../components/common/button/Button";
import styles from "./Reference.scss";

import Textarea from "../../../../components/common/textarea/Textarea";
import { Form, FormGroup } from "react-bootstrap";
import { required, maxLength } from "../../../../utils/forms/validators";
import emptyStarIcon from "../../../../assets/images/empty-star.svg";
import filledStarIcon from "../../../../assets/images/filled-star.svg";
import Ratings from "./Ratings";
import ReferenceSkills from "./ReferenceSkills";
import { ReferenceText } from "./Reference/ReferenceText";
import { ReferenceHeaderText } from "./Reference/ReferenceHeaderText";
import { ReferenceFormFields } from "./Reference/ReferenceFormFields";
import { WORK_REFERENCE_FORM } from "../../../../actions/workReferences.actions";

export const maxLengthValidation = (max, msg) => maxLength(max, msg);
export const anythingElse = maxLengthValidation(
  1000,
  "This field must be less than or equal to 1000 characters."
);
const skillValidation = values => {
  return _.find(values, value => {
    return value;
  })
    ? false
    : "Required";
};

class Reference extends Component {
  render() {
    const {
      handleSubmit,
      submitting,
      valid,
      reference,
      referenceRelationships
    } = this.props;

    if (!reference) return null;

    const firstName =
      reference.referenced_by && reference.referenced_by.first_name;
    const lastName =
      reference.referenced_by && reference.referenced_by.last_name;
    const fullName = `${firstName} ${lastName}`;

    return (
      <section>
        <section className={styles.reference}>
          <div className={styles.content}>
            <ReferenceHeaderText fullName={fullName} />

            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <ReferenceText
                  name={reference.name}
                  firstName={firstName}
                  fullName={fullName}
                />

                <FormGroup>
                  <div className={styles.dividerDouble} />

                  <div className={styles.sectionTitle}>Reference Info</div>

                  <ReferenceFormFields
                    referenceRelationships={referenceRelationships}
                  />

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Skills</div>
                  <div className={styles.sectionDescription}>
                    Please select the skills&nbsp;
                    {firstName} used when you worked together.
                  </div>

                  <div className={styles.skills}>
                    <Field
                      name="skills"
                      component={ReferenceSkills}
                      skills={reference.suggested_skills}
                      validate={skillValidation}
                    />
                  </div>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>
                    Your Experience Working with&nbsp;
                    {firstName}
                  </div>
                  <div className={styles.sectionDescription} />

                  {this.props.questions &&
                    this.props.questions.map((q, index) => (
                      <div>
                        <Field
                          name={`answers.${q.id}`}
                          component={Ratings}
                          emptyIcon={emptyStarIcon}
                          filledIcon={filledStarIcon}
                          text={q.question.replace(
                            "{{reference_name}}",
                            firstName
                          )}
                          validate={required}
                        />

                        {index + 1 < this.props.questions.length && (
                          <div className={styles.dividerPadding} />
                        )}
                      </div>
                    ))}

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Anything Else?</div>

                  <Field
                    name="comments"
                    type="textarea"
                    placeholder="Please provide any additional comments."
                    component={Textarea}
                    //help='1,000 characters max'
                    maxlength={1000}
                    validate={anythingElse}
                  />
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div className={styles.CTAContainer}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="Submit"
                    isDisabled={!valid || submitting}
                  />
                </div>
                {/* <div>
                  <a className={styles.decline} onClick={this.props.onDecline}>Decline reference ›</a>
                </div> */}
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

export default reduxForm({
  form: WORK_REFERENCE_FORM,
  enableReinitialize: true
})(Reference);



// WEBPACK FOOTER //
// ./src/routes/admin/reference/components/Reference.js